import React from "react";

interface MessageContainerProps {
  isMine: boolean;
  children: React.ReactNode;
}

const MessageContainer = ({ isMine, children }: MessageContainerProps) => (
  <div className={`flex flex-col items-${isMine ? 'end' : 'start'} mb-4`}>
    {children}
  </div>
);

export default MessageContainer;